/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./progress.component.sass.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./progress.component";
var styles_ProgressComponent = [i0.styles];
var RenderType_ProgressComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ProgressComponent, data: {} });
export { RenderType_ProgressComponent as RenderType_ProgressComponent };
export function View_ProgressComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "loader"]], null, null, null, null, null))], null, null); }
export function View_ProgressComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-progress", [], null, null, null, View_ProgressComponent_0, RenderType_ProgressComponent)), i1.ɵdid(1, 114688, null, 0, i2.ProgressComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ProgressComponentNgFactory = i1.ɵccf("app-progress", i2.ProgressComponent, View_ProgressComponent_Host_0, {}, {}, []);
export { ProgressComponentNgFactory as ProgressComponentNgFactory };
